import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useSsrAdapter as V } from "../../../../../../@css-render_vue3-ssr@0.15.14_vue@3.5.18/node_modules/@css-render/vue3-ssr/esm/index.js";
import j from "../../lazy-teleport/src/index.js";
import { getPlacementAndOffsetOfFollower as k, getProperTransformOrigin as _, getOffset as U } from "./get-placement-style.js";
import { getPointRect as X, getRect as m } from "./utils.js";
import P from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import { cssrAnchorMetaName as Y, c as a } from "../../shared/cssr.js";
import q from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/on-fonts-ready.js";
import { defineComponent as G, inject as H, onMounted as J, onBeforeUnmount as K, watch as d, nextTick as Q, h, withDirectives as Z } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import ee from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/life-cycle/use-is-mounted.js";
import te from "../../../../../../vdirs@0.1.8_vue@3.5.18/node_modules/vdirs/es/zindexable/index.js";
import { ref as A, toRef as p } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const ne = a([
  a(".v-binder-follower-container", {
    position: "absolute",
    left: "0",
    right: "0",
    top: "0",
    height: "0",
    pointerEvents: "none",
    zIndex: "auto"
  }),
  a(".v-binder-follower-content", {
    position: "absolute",
    zIndex: "auto"
  }, [
    a("> *", {
      pointerEvents: "all"
    })
  ])
]), pe = G({
  name: "Follower",
  inheritAttrs: !1,
  props: {
    show: Boolean,
    enabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: "bottom"
    },
    syncTrigger: {
      type: Array,
      default: ["resize", "scroll"]
    },
    to: [String, Object],
    flip: {
      type: Boolean,
      default: !0
    },
    internalShift: Boolean,
    x: Number,
    y: Number,
    width: String,
    minWidth: String,
    containerClass: String,
    teleportDisabled: Boolean,
    zindexable: {
      type: Boolean,
      default: !0
    },
    zIndex: Number,
    overlap: Boolean
  },
  setup(n) {
    const t = H("VBinder"), o = P(() => n.enabled !== void 0 ? n.enabled : n.show), v = A(null), g = A(null), b = () => {
      const { syncTrigger: e } = n;
      e.includes("scroll") && t.addScrollListener(r), e.includes("resize") && t.addResizeListener(r);
    }, y = () => {
      t.removeScrollListener(r), t.removeResizeListener(r);
    };
    J(() => {
      o.value && (r(), b());
    });
    const B = V();
    ne.mount({
      id: "vueuc/binder",
      head: !0,
      anchorMetaName: Y,
      ssr: B
    }), K(() => {
      y();
    }), q(() => {
      o.value && r();
    });
    const r = () => {
      if (!o.value)
        return;
      const e = v.value;
      if (e === null)
        return;
      const O = t.targetRef, { x, y: R, overlap: l } = n, i = x !== void 0 && R !== void 0 ? X(x, R) : m(O);
      e.style.setProperty("--v-target-width", `${Math.round(i.width)}px`), e.style.setProperty("--v-target-height", `${Math.round(i.height)}px`);
      const { width: f, minWidth: c, placement: z, internalShift: E, flip: N } = n;
      e.setAttribute("v-placement", z), l ? e.setAttribute("v-overlap", "") : e.removeAttribute("v-overlap");
      const { style: s } = e;
      f === "target" ? s.width = `${i.width}px` : f !== void 0 ? s.width = f : s.width = "", c === "target" ? s.minWidth = `${i.width}px` : c !== void 0 ? s.minWidth = c : s.minWidth = "";
      const C = m(e), W = m(g.value), { left: S, top: T, placement: u } = k(z, i, C, E, N, l), L = _(u, l), { left: I, top: D, transform: F } = U(u, W, i, T, S, l);
      e.setAttribute("v-placement", u), e.style.setProperty("--v-offset-left", `${Math.round(S)}px`), e.style.setProperty("--v-offset-top", `${Math.round(T)}px`), e.style.transform = `translateX(${I}) translateY(${D}) ${F}`, e.style.setProperty("--v-transform-origin", L), e.style.transformOrigin = L;
    };
    d(o, (e) => {
      e ? (b(), w()) : y();
    });
    const w = () => {
      Q().then(r).catch((e) => console.error(e));
    };
    [
      "placement",
      "x",
      "y",
      "internalShift",
      "flip",
      "width",
      "overlap",
      "minWidth"
    ].forEach((e) => {
      d(p(n, e), r);
    }), ["teleportDisabled"].forEach((e) => {
      d(p(n, e), w);
    }), d(p(n, "syncTrigger"), (e) => {
      e.includes("resize") ? t.addResizeListener(r) : t.removeResizeListener(r), e.includes("scroll") ? t.addScrollListener(r) : t.removeScrollListener(r);
    });
    const M = ee(), $ = P(() => {
      const { to: e } = n;
      if (e !== void 0)
        return e;
      M.value;
    });
    return {
      VBinder: t,
      mergedEnabled: o,
      offsetContainerRef: g,
      followerRef: v,
      mergedTo: $,
      syncPosition: r
    };
  },
  render() {
    return h(j, {
      show: this.show,
      to: this.mergedTo,
      disabled: this.teleportDisabled
    }, {
      default: () => {
        var n, t;
        const o = h("div", {
          class: ["v-binder-follower-container", this.containerClass],
          ref: "offsetContainerRef"
        }, [
          h("div", {
            class: "v-binder-follower-content",
            ref: "followerRef"
          }, (t = (n = this.$slots).default) === null || t === void 0 ? void 0 : t.call(n))
        ]);
        return this.zindexable ? Z(o, [
          [
            te,
            {
              enabled: this.mergedEnabled,
              zIndex: this.zIndex
            }
          ]
        ]) : o;
      }
    });
  }
});
export {
  pe as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/binder/src/Follower.js
// module id = 171
// module chunks = 41